<script setup lang="ts">
import {ref} from 'vue'
import InfoModal from "@/components/info/infoModal.vue";

const props = withDefaults(defineProps<{
  filterName: string
  initFilterOpen?: boolean
  filterLabel: string
  filterValue: string
  rawFilterValue?: string
  rawStoneType?: string
  showInfo?: boolean
}>(), {
  initFilterOpen: true,
  filterLabel: '',
  filterValue: '',
  rawFilterValue: '',
  rawStoneType: '',
  showInfo: true
});

const isFilterOpen = ref(props.initFilterOpen)

</script>

<template>
  <div class="filter-row border-b border-gray-100 pt-4 pb-2">
    <div class="flex justify-between items-center cursor-pointer group" @click="isFilterOpen = !isFilterOpen">
      <div class="flex gap-2 items-center">
        <h3 class="font-bold text-sm text-gray-900 tracking-tight">{{ filterLabel }}:</h3>
        <span class="text-sm text-gray-500 font-light">{{ filterValue }}</span>
        <info-modal v-if="showInfo && filterName != 'stone_size'" :id="filterName" :value="rawFilterValue" :stone-type="rawStoneType" />
      </div>
      <div class="text-gray-400 group-hover:text-gray-500 transition-colors">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4 transition-transform duration-300"
            :class="{ 'rotate-180': isFilterOpen }"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </div>

    <div v-if="isFilterOpen" class="mt-6 overflow-x-auto no-scrollbar scroll-smooth">
      <slot/>
    </div>
  </div>
</template>

<style scoped>

</style>